import React from 'react';
import { Typography } from '@douyinfe/semi-ui';
import { getModuleConfig } from '../moduleTypes';
import styles from './style.module.scss';

// 导入各个模块的样式表单组件
import { DanmakuStyleForm } from '../modules/Danmaku/editor';
import { GroupInfoStyleForm } from '../modules/GroupInfo/editor';
import { GroupTextStyleForm } from '../modules/GroupText/editor';
import { FAQStyleForm } from '../modules/FAQ/editor';
import { BottomButtonStyleForm } from '../modules/BottomButton/editor';
import { SingleImageStyleForm } from '../modules/SingleImage/editor';
import { RichTextStyleForm } from '../modules/RichText/editor';
import { HotspotImageStyleForm } from '../modules/HotspotImage/editor';

const { Title } = Typography;

const PropertyEditor = ({ selectedModule, onChange }) => {
    if (!selectedModule) {
        return (
            <div className={styles.propertyEditor}>
                <div className={styles.placeholder}>
                    请选择要编辑的模块
                </div>
            </div>
        );
    }

    const moduleConfig = getModuleConfig(selectedModule.type);
    if (!moduleConfig) return null;

    const renderStyleForm = () => {
        switch (selectedModule.type) {
            case 'DANMAKU':
                return <DanmakuStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'GROUP_INFO':
                return <GroupInfoStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'GROUP_TEXT':
                return <GroupTextStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'FAQ':
                return <FAQStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'BOTTOM_BUTTON':
                return <BottomButtonStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'SINGLE_IMAGE':
                return <SingleImageStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'RICH_TEXT':
                return <RichTextStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            case 'HOTSPOT_IMAGE':
                return <HotspotImageStyleForm key={`${selectedModule.type}-${selectedModule.id}`} data={selectedModule.data} onChange={onChange} />;
            default:
                return null;
        }
    };

    return (
        <div className={styles.propertyEditor}>
            <Title heading={6}>{moduleConfig.title} - 属性设置</Title>
            <div className={styles.properties}>
                {renderStyleForm()}
            </div>
        </div>
    );
};

export default PropertyEditor;